import React from 'react';
import { raygun } from '@ynap/clientside-monitoring';
import { node, string } from 'prop-types';

// Will error on SSR https://github.com/facebook/react/issues/10442
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: false };
    }

    static getDerivedStateFromError() {
        return { error: true };
    }

    componentDidCatch(error) {
        raygun.helpers.agent('send', { error, tags: [this.props.editorialId, this.props.selectedPartNumber, 'editorial', 'pdp'] });
    }

    render() {
        if (this.state.error) {
            return null;
        }

        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    children: node,
    selectedPartNumber: string,
    editorialId: string,
};

export default ErrorBoundary;
